import { AdacButton } from '@adac-de/component-library';
import React from 'react';
import styles from './underlined-button.module.scss';
import { Icon } from '@components/icons/icons';
import { ColorName } from '@utils/colors';

type UnderlinedButtonProps = JSX.IntrinsicElements['button'] & {
  label: string;
  withInfoIcon?: boolean;
  iconSize?: number;
  dataTestId?: string;
  iconFillColor?: ColorName;
};

export const UnderlinedButton: React.FC<UnderlinedButtonProps> = ({
  label,
  onClick,
  withInfoIcon = false,
  iconSize = 20,
  dataTestId,
  iconFillColor = 'black90'
}) => (
  <AdacButton
    variant="unstyled"
    onClick={onClick}
    className={styles.button}
    data-testid={dataTestId}
  >
    {label}{' '}
    {withInfoIcon && (
      <Icon.Info width={iconSize} height={iconSize} fill={iconFillColor} isOutlined />
    )}
  </AdacButton>
);
